module.exports = __webpack_public_path__ + "static/media/circle-shape-png-hd-background-view-all-images.f090ddee.png";